<template>
    <ul class="lni-c-app-progress-bar">
        <li
            class="lni-c-app-progress-bar__step"
            v-for="option in options"
            v-bind:key="option.value"
            :class="{
                'current-tab': option.value === thisRoute,
                'route-has-error': routeHasErrors(option.value),
                'link-is-enabled': isEnabled(option.value)
            }">
            <router-link
                class="lni-c-app-progress-bar__link"
                v-if="isEnabled(option.value)"
                :to="`/${option.value}`">
                <span class="lni-c-app-progress-bar__text">
                    <span v-if="routeHasErrors(option.value)" class="lnicon--exclamation lni-u-pr1" aria-hidden="true"></span>{{ option.text }}
                    <span v-if="routeHasErrors(option.value)" class="lni-u-visually-hidden">...has errors</span>
                </span>
            </router-link>
            <span
                class="lni-c-app-progress-bar__text"
                v-else>{{ option.text }}</span>
        </li>
    </ul>
</template>

<script>
/**
 *  The x-application-progress-bar component.
 *  @module components/x-application-progress-bar
 */

import framework from '../../framework';


/**
 * The x-application-progress-bar is a app flow menu.
 */

export default {
    name: 'x-application-progress-bar',
    mixins: [
        framework.mixins.abstractElement,
    ],
    props: {
        dataOptions: Array,
        dataRouteHasErrors: Boolean,
        dataIsEnabled: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        /**
         * The list of link options
         * @returns {*} array of options.
         */
        options() {
            return this.getOptions();
        },
        /**
         * The route, with the beginning slash removed.
         * @returns {String} the route.
         */
        thisRoute() {
            return this.$route.path.substr(1);
        },
    },
    methods: {
        /**
         * Whether the route for this link has errors.
         * @param {String} routePath The path of the route.
         * @returns {Boolean} has errors.
         */
        routeHasErrors(routePath) {
            let formattedPath = `/${routePath}`;
            return !this.$store.getters.canNavigateFromRoute(formattedPath);
        },
        /**
         * Whether the link is enabled.
         * @param {String} routePath The path of the route.
         * @returns {Boolean} is enabled.
         */
        isEnabled(routePath) {
            let formattedPath = `/${routePath}`;
            if (this.$store.getters.canNavigateToRoute(formattedPath, this.$route.path)) {
                return true;
            }

            return false;
        },
    },
};
</script>

<style lang="scss">
    @import
        "../../styles/settings.scss",
        "application-progress-bar.scss";
</style>



// WEBPACK FOOTER //
// source/components/x-application-progress-bar/x-application-progress-bar.vue